import type { ReactNode } from 'react';
import Typography from '@mui/material/Typography';

interface SectionHeadingProps {
  children: ReactNode;
  level?: 'h2' | 'h3' | 'h4';
  className?: string;
}

export function SectionHeading({ children, level = 'h2', className }: SectionHeadingProps) {
  return (
    <Typography
      variant="overline"
      component={level}
      className={className}
      sx={{ color: 'var(--primary)', fontWeight: 700, letterSpacing: 0 }}
    >
      {children}
    </Typography>
  );
}